import React, { useEffect, useRef } from 'react';
import clsx from 'classnames';
import './index.css';
import Banner from './components/Banner';
import Service from './components/Service';
import About from './components/About';
import Enterprise from './components/Enterprise';
import { useAppContext } from '../../context/AppContext';
import { useLocation } from 'react-router-dom';

const HomePage = () => {
  const serviceRef = useRef(null);
  const {
    state: { click },
    dispatch,
  } = useAppContext();
  const { pathname } = useLocation();

  const scrollToService = () => {
    if (serviceRef.current) {
      serviceRef.current.scrollIntoView({
        behavior: 'smooth', // 平滑滚动
      });
    }
  };

  useEffect(() => {
    dispatch({ type: 'SET_CLICK', payload: scrollToService });
  }, []);

  useEffect(() => {
    // 当路径为 /service，且 click 函数存在时执行
    if (pathname === '/service' && typeof click === 'function') {
      // 建议加上 setTimeout，防止页面刚切换时 DOM 还未完全渲染完毕
      const timer = setTimeout(() => {
        click();
      }, 300);
      // 清除定时器，防止内存泄漏
      return () => clearTimeout(timer);
    }
  }, [pathname, click]);

  return (
    <div className={clsx('page-top')} style={{ minHeight: window.innerHeight }}>
      {/* 顶部Banner */}
      <Banner />
      {/* 关于上检 */}
      <About />
      {/* 服务项目 */}
      <div id='service' ref={serviceRef}>
        <Service />
      </div>
      {/* 企业实力 */}
      <Enterprise />
    </div>
  );
};

export default HomePage;
